module.exports = __webpack_public_path__ + "img/search-cat.9f16119e.jpg";